"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var vue_property_decorator_1 = require("vue-property-decorator");
var CampaignFactoryAlertComponent = (function (_super) {
    __extends(CampaignFactoryAlertComponent, _super);
    function CampaignFactoryAlertComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.successSnackbar = false;
        _this.errorSnackbar = false;
        return _this;
    }
    CampaignFactoryAlertComponent.prototype.data = function () {
        return {
            successMessage: this.successMessage,
            errorMessage: this.errorMessage
        };
    };
    CampaignFactoryAlertComponent.prototype.hideSnacks = function () {
        this.successSnackbar = false;
        this.errorSnackbar = false;
    };
    CampaignFactoryAlertComponent.prototype.displaySuccess = function (message) {
        this.successMessage = message;
        this.successSnackbar = true;
    };
    CampaignFactoryAlertComponent.prototype.displayError = function (message) {
        this.errorMessage = message;
        this.errorSnackbar = true;
    };
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", Object)
    ], CampaignFactoryAlertComponent.prototype, "testResponse", void 0);
    CampaignFactoryAlertComponent = __decorate([
        vue_class_component_1.default
    ], CampaignFactoryAlertComponent);
    return CampaignFactoryAlertComponent;
}(vue_1.default));
exports.default = CampaignFactoryAlertComponent;
